export default "__VITE_ASSET__Chs6Y_iw__"